import { Typography, useTheme, lighten } from "@mui/material";
import React from "react";
import { DateDescriptionContainer, InfoContainer, DescriptionText } from "./styles";
import SvgFromString from "../../../../../../../../../reusable-components/IconsSelect/SvgFromString/SvgFromString";
import { intlFormatDateShort } from "../../../../../../../../../utils/time-utils";

interface Props {
  type: string;
  date: Date;
  description: string;
  typeIconContent: string | undefined;
  flex?: number;
}

const TypeAndDescription = ({ type, date, description, typeIconContent, flex }: Props) => {
  const theme = useTheme();

  return (
    <DateDescriptionContainer flex={flex}>
      <>
        {typeIconContent && (
          <SvgFromString
            svgString={typeIconContent}
            color={lighten(theme.palette.text.primary, 0.2)}
            width={"50px"}
            height={"50px"}
            title={type}
          />
        )}
      </>

      <InfoContainer>
        {!!description && <DescriptionText>{description}</DescriptionText>}
        {!!date && <Typography>{intlFormatDateShort(date)}</Typography>}
      </InfoContainer>
    </DateDescriptionContainer>
  );
};

export default TypeAndDescription;
